import { Phone, Mail, Globe } from "lucide-react";
import { CONTACT } from "@/data/site";

export const StickyContactBar = () => {
  return (
    <div
      data-testid="sticky-contact-bar"
      className="fixed inset-x-0 bottom-0 z-50 grid grid-cols-3 border-t border-[#0B3B38]/20 bg-white shadow-[0_-4px_20px_rgba(0,0,0,0.1)] lg:hidden"
    >
      <a href={CONTACT.phoneHref} className="flex flex-col items-center gap-0.5 py-2.5 text-[#0E9E96]">
        <Phone className="h-5 w-5" />
        <span className="text-[11px] font-extrabold">Call</span>
      </a>
      <a href={`mailto:${CONTACT.email}`} className="flex flex-col items-center gap-0.5 border-x border-[#E2ECEE] py-2.5 text-[#F97316]">
        <Mail className="h-5 w-5" />
        <span className="text-[11px] font-extrabold">Email</span>
      </a>
      <a href={CONTACT.websiteHref} target="_blank" rel="noopener noreferrer" className="flex flex-col items-center gap-0.5 py-2.5 text-slate-600">
        <Globe className="h-5 w-5" />
        <span className="text-[11px] font-extrabold">Website</span>
      </a>
    </div>
  );
};
